//React imports
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

//Component imports
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index";
import BalanceLoader from "../../../../components/_utils/BalanceLoader/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import MinimumBal from "../../../../components/_utils/MinimumBalance/index.jsx";
import CommonCalendar from "../../../../components/_utils/CommonCalendar/index.jsx";
import OwnerAccountStatisticsGraph from "../../../../components/Accounts/OwnerAccount/OwnerAccountStatisticsGraph/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import SingleSelectDropDownComponent from "../../../../components/_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import OwnerAccountItemisedReportComp from "../../../../components/Accounts/OwnerAccount/OwnerAccountConsolidatedLiveStatementComp/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import CommonAssignTagPopup from "../../../../components/_utils/CommonPopups/CommonAssignTagPoppup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import SmallPopupWithBulletPoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CardActionableButton from "../../../../components/_utils/CommonViewAllCard/CardSubComponent/CardActionableButton/index.jsx";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup/index.jsx";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox/index.jsx";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import InternalTransactionViewAll from "../../../Transactions/InternalTransactions/InternalTransactionViewAll/index.jsx";
import OwnerAllStatement from "../OwnerAccountConsolidatedBankStatement/index.jsx";
import GSTVerification from "../../../Settings/GSTDetails/index.jsx";
import ICONS from "../../../../assets/Icons/index.js";

//Redux imports
import {
  ownerAccountsDetailsById,
  ownerAccountsAddTag,
  ownerAccountsRemoveTag,
  setTags,
  ownerAccountsBalanceRefresh,
  setshowsuccestoast,
  ownerAccountsHistoricBalanceReport,
  ownerAccountsAddFavourite,
  ownerAccountsRemoveFavourite,
  updateOwnerDetailsById,
  ownerAccountsAddLabel,
  ownerAccountsRemoveLabel,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { getAllInternalAccounts } from "../../../../redux/features/accounts/internalAccount/index.js";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";

//Utils imports
import globalText from "../../../../utils/globalText.js";
import formatTotalBalance from "../../../../utils/formatTotalBalance.js";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import IFSCDetails from "../../../Settings/IFSCDetails/index.jsx";
import PanVerification from "../../../Settings/PanVerification/index.jsx";
import TEXT from "../../../../utils/globalText.js";
import {
  errorcode,
  GlobalConfiguration,
} from "../../../../utils/configurationProvider.js";

function OwnerAccountDetails(props) {
  // Route and Redux helpers used to load account data and perform account actions.
  const { id } = useParams();

  const dispatch = useDispatch();

  const infoRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const navigate = useNavigate();

  // Tracks the page's initial and action-related loading state.
  const [loading, setLoading] = useState(true);
  // Controls the assigned label popup.
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  // Controls the bank statement popup.
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  // Controls the itemised statement popup.
  const [viewItemisedOpenPop, setViewItemisedOpenPop] = useState(false);
  // Controls the assigned tag popup.
  const [selectedTagOpenPop, setSelectedTagOpenPop] = useState(false);
  // Holds the account record currently displayed on the page.
  const [ownerDetailData, setOwnerdetaildata] = useState([]);
  // Stores the related account identifier used by the view.
  const [accId, setAccId] = useState("");
  // Stores the refreshed connected balance for comparison.
  const [currentConnectedBal, setCurrentConnectedBal] = useState("");
  // Stores the connected balance value before the latest refresh.
  const [prevConnectedBal, setPrevConnectedBal] = useState("");
  // Selects the account details tab.
  const [showDetails, setShowDetails] = useState(true);
  // Selects the account statistics tab.
  const [showStatistics, setShowStatistics] = useState(false);
  // Selects the assigned tags tab.
  const [showAssignedTags, setShowAssignedTags] = useState(false);
  // Controls the internal transaction history view.
  const [openHistory, setOpenHistory] = useState(false);
  // Controls the beneficiary transaction history view.
  const [openBeneHistory, setOpenBeneHistory] = useState(false);
  // Stores the current editable tag selections.
  const [newTags, setNewTags] = useState([]);
  // Stores tags already assigned to the account.
  const [existingTags, setExistingTags] = useState([]);
  // Stores the complete available tag list.
  const [AllTags, setAllTags] = useState([]);
  // Toggles minimum-balance filtering in the view.
  const [minBalance, setMinBalance] = useState(false);
  // Initializes the minimum-balance threshold from local storage.
  const [amount, setAmount] = useState(() => {
    const savedAmount = localStorage.getItem("minBalanceAmount");
    return savedAmount ? savedAmount : "";
  });
  // Start date used by the statistics date picker.
  const [startDateState, setStartDateState] = useState(
    new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
  );
  // End date used by the statistics date picker.
  const [endDateState, setEndDateState] = useState(new Date());
  // Labels available to assign to this account.
  const [labels, setLabels] = useState([]);
  // Start date used by statistics report requests.
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
  );
  // End date used by statistics report requests.
  const [endDate, setEndDate] = useState(new Date());
  const haveName = newTags?.some((val) => val?.type === "ownerTags");
  // Selects how report amounts are displayed.
  const [amountRange, setAmountRange] = useState("Absolute (amount)");
  // Stores the selected amount range or formatting value.
  const [amountRangeValue, setAmountRangeValue] = useState("");
  // Interest rate used for missed-income calculations.
  const [investmentRateValue, setInvestmentRateValue] = useState(6.62);
  // Stores the selected period's balance report rows.
  const [accountBalancesReportData, setAccountBalancesReportData] = useState(
    [],
  );
  // Stores the full selected-period balance report response.
  const [accountBalancesReportAllData, setAccountBalancesReportAllData] =
    useState([]);
  // Stores the weekly balance report rows.
  const [accountBalancesReportWeekData, setAccountBalancesReportWeekData] =
    useState([]);
  // Stores the full weekly balance report response.
  const [
    accountBalancesReportWeekAllData,
    setAccountBalancesReportWeekAllData,
  ] = useState([]);
  // Holds an error from the selected-period report request.
  const [accountBalancesReportError, setAccountBalancesReportError] =
    useState("");
  // Holds an error from the weekly report request.
  const [accountBalancesReportWeekError, setAccountBalancesReportWeekError] =
    useState("");
  // Controls visibility of the report information tooltip.
  const [infoState, setInfoState] = useState(false);
  // Stores weekly missed-income chart values.
  const [missedIncomeGraphData, setMissedIncomeGraphData] = useState([
    0, 0, 0, 0, 0, 0, 0,
  ]);
  // Stores weekly actual-income chart values.
  const [actualIncomeGraphData, setActualIncomeGraphData] = useState([
    0, 0, 0, 0, 0, 0, 0,
  ]);
  // Indicates whether this account is currently marked as a favourite.
  const [isFavTagExist, setIsFavTagExist] = useState(false);

  // Stores labels currently attached to the account.
  const [labelDetails, setLabelDetails] = useState([]);

  // Controls GST verification popup.
  const [showGstPopup, setGstShowPopup] = useState(false);
  // Controls PAN verification popup.
  const [showPanPopup, setPanShowPopup] = useState(false);
  // Controls IFSC verification popup.
  const [showIfscPopup, setIfscShowPopup] = useState(false);

  // Controls the transaction-type chooser.
  const [showModal, setShowModal] = useState(false);
  // Stores the transaction type selected in the chooser.
  const [selectedTxnTypeChipIndex, setSelectedTxnTypeChipIndex] = useState("");
  // Controls the favourite confirmation popup.
  const [showFavPopup, setFavShowPopup] = useState(false);
  // Indicates a favourite update is in progress.
  const [isFavLoading, setIsFavLoading] = useState(false);
  // Controls the credit-limit editor.
  const [showCreditLimitPopup, setShowCreditLimitPopup] = useState(false);
  // Holds the credit-limit value being edited.
  const [creditLimitInput, setCreditLimitInput] = useState("");
  // Keeps the saved credit limit for change detection.
  const [initialCreditLimit, setInitialCreditLimit] = useState("");
  // Indicates a credit-limit update is in progress.
  const [isCreditLimitLoading, setIsCreditLimitLoading] = useState(false);
  // Indicates an account-type update is in progress.
  const [accountTypeLoading, setAccountTypeLoading] = useState(false);
  // Controls the account-type selector popup.
  const [accountTypePopup, setShowAccountTypePopup] = useState(false);
  // Stores the account-type chip currently selected.
  const [selectedChipIndex, setSelectedChipIndex] = useState("");
  // Controls the amount information popup.
  const [infoAmountPopup, setInfoAmountPopup] = useState(false);
  // Controls the minimum-limit editor.
  const [showMinimumLimitPopup, setShowMinimumLimitPopup] = useState(false);
  // Holds the minimum balance value being edited.
  const [minimumLimitInput, setMinimumLimitInput] = useState("");
  // Keeps the saved minimum balance for change detection.
  const [initialMinimumLimit, setInitialMinimumLimit] = useState("");
  // Indicates a minimum-limit update is in progress.
  const [isMinimumLimitLoading, setIsMinimumLimitLoading] = useState(false);
  // Controls the maximum-limit editor.
  const [showMaximumLimitPopup, setShowMaximumLimitPopup] = useState(false);
  // Holds the maximum balance value being edited.
  const [maximumLimitInput, setMaximumLimitInput] = useState("");
  // Keeps the saved maximum balance for change detection.
  const [initialMaximumLimit, setInitialMaximumLimit] = useState("");
  // Indicates a maximum-limit update is in progress.
  const [isMaximumLimitLoading, setIsMaximumLimitLoading] = useState(false);

  // Selects the currently visible carousel item.
  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  // Tracks the previous carousel item to determine animation direction.
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  // Holds the CSS class for the carousel transition.
  const [animationClass, setAnimationClass] = useState("");
  // Selects the balance category displayed in the carousel.
  const [balanceType, setBalanceType] = useState("credit");

  // Retrieves internal accounts matching this owner's bank details.
  const { getAllInternalAccountData } = useSelector(
    (state) => state.internalAccount,
  );
  // Reads the selected date range for bank statements from Redux.
  const { startDate: bankStatementStartDate, endDate: bankStatementEndDate } =
    useSelector((state) => state.ownerAllVerification);

  // Reads the selected date range for live statements from Redux.
  const { startDate: liveStatementStartDate, endDate: liveStatementEndDate } =
    useSelector((state) => state.remitterAccount);

  // Reads owner-account loading, tag, statistics, and refresh status from Redux.
  const {
    ownerAccBalanceLoading,
    ownerAccBalanceError,
    ownerAccountAvailableTags,
    showSuccessToast,
    ownerAccountsRemoveTagsLoading,
    getOwnerAccStatiticsLoading,
    getOwnerAccWeekStatiticsLoading,
    ownerAccountsDetailData,
  } = useSelector((state) => state.ownerAllVerification);

  // Gets the active services used to gate account features and actions.
  const services = useSelector((state) => state.refreshToken.services);

  // Provides a helper to verify that required services are enabled.
  const [ensureAll] = useServiceChecker();

  // Provides the restricted-action dialog and its trigger helper.
  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  // Shared date and capability flags used to decide which actions are available.
  const currentDate = new Date();
  currentDate.setDate(
    currentDate.getDate() - GlobalConfiguration?.lengthCheckOne,
  );

  // Indicates whether the account is archived and should restrict actions.
  const isArchived =
    ownerAccountsDetailsById?.beneficiary_accounts?.approval_status ===
    "archived";

  // Checks whether label assignment service access is enabled.
  const hasALabel = services?.includes("ALabel");
  // Checks whether label removal service access is enabled.
  const hasRLabel = services?.includes("RLabel");
  // Indicates whether an account-type chip has been selected.
  const isAccountTypeSelected =
    selectedChipIndex !== "" && selectedChipIndex !== null;

  // Checks access to beneficiary transaction history.
  const hasBeneTxnHistoryService = services?.includes("VBeneficiaryTxn");
  // Checks access to internal transaction history.
  const hasInternalTxnHistoryService = services?.includes("VInternalTxn");
  // Indicates whether the component is shown in a restricted popup context.
  const isOwnerPopupRestricted =
    props?.popType === "ownerStatement" ||
    props?.popType === "reimburseowner_details";
  // Indicates whether a transaction-history type has been selected.
  const isTxnTypeSelected =
    selectedTxnTypeChipIndex !== "" && selectedTxnTypeChipIndex !== null;

  // Indicates that one or both required label services are unavailable.
  const isServiceMissing = !(hasALabel && hasRLabel);

  // Opens the restricted-action flow for this account's details page.
  const actionRestricted = () => {
    showRestrictedAction({
      path: `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${props.ownerDetailId || props.Remibursement_owneraccount_id}`,
    });
  };

  // Dont remove
  // Start Date - 2025-11-01
  // End Date - 2025-11-07

  // Formats dates for display or as the day-month-year API value.
  const formatDate = (
    dateString,
    withComma = false,
    dateType = false,
    short = true,
  ) => {
    if (dateType) {
      let date = new Date(dateString);
      const day = String(date?.getDate()).padStart(
        GlobalConfiguration?.lengthCheckTwo,
        "0",
      );
      const month = String(
        date?.getMonth() + GlobalConfiguration?.lengthCheckOne,
      ).padStart(GlobalConfiguration?.lengthCheckTwo, "0");
      const year = date?.getFullYear();

      return day + "-" + month + "-" + year;
    } else {
      return `${dateString?.getDate()} ${dateString?.toLocaleString("default", {
        month: short ? "short" : "long",
      })}${withComma ? "," : ""} ${dateString?.getFullYear()}`;
    }
  };

  // Shows the processing toast used while account updates are in progress.
  const showToast = (message) => {
    CommonToast({
      text: message,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  // Identifies balances that are missing, invalid, or masked by the API.
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };

  // Toggles the selected account-type chip.
  const handleChipClick = (id) => {
    if (selectedChipIndex === id) {
      setSelectedChipIndex("");
    } else {
      setSelectedChipIndex(id);
    }
  };

  // Loads the selected owner account and syncs its tags and related accounts.
  const getOwnerDetaildata = async () => {
    setLoading(true);

    try {
      let response;

      if (props?.popType == "ownerStatement") {
        response = await dispatch(
          ownerAccountsDetailsById(props?.ownerDetailId),
        );
      } else if (props?.popType == "reimburseowner_details") {
        response = await dispatch(
          ownerAccountsDetailsById(props?.Remibursement_owneraccount_id),
        );
      } else {
        response = await dispatch(ownerAccountsDetailsById(id));
      }
      if (
        response?.payload?.owner_accounts?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        setLabelDetails(
          response.payload.owner_accounts[GlobalConfiguration.lengthCheckZero]
            ?.labels || [],
        );
      }
      // If response is empty or has an error, navigate to 404 page
      if (
        !response?.payload ||
        response?.error?.status === errorcode.errorNotFound
      ) {
        navigate("/*");
        return;
      }

      dispatch(
        getAllInternalAccounts({
          bank_account_no:
            response?.payload?.owner_accounts[
              GlobalConfiguration.lengthCheckZero
            ]?.bank_acc_no,
          ifsc: response?.payload?.owner_accounts[
            GlobalConfiguration.lengthCheckZero
          ]?.ifsc_code,
          pan: response?.payload?.owner_accounts[
            GlobalConfiguration.lengthCheckZero
          ]?.pan_no,
        }),
      );

      setOwnerdetaildata(
        response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero],
      );
      setIsFavTagExist(
        (response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
          ?.favourite ?? "N") === "Y",
      );

      if (
        response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
          ?.tags &&
        response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
          ?.tags.length > GlobalConfiguration?.lengthCheckZero
      ) {
        const data = response?.payload?.owner_accounts[
          GlobalConfiguration.lengthCheckZero
        ].tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
        setLoading(true);
      } else {
        setNewTags([]);
      }

      setLoading(false);

      if (response?.error?.message == "Request failed with status code 404") {
        navigate("/*");
      }

      if (response?.payload === undefined) {
        navigate("/feature_not_assigned");
      }
    } catch (error) {
      setLoading(false);
      navigate("/*");
    }
  };

  // Assigns one or more tags, then reloads the account after success.
  const handleAddTags = async (item) => {
    try {
      let response = await dispatch(
        ownerAccountsAddTag({
          owner_id: [id],
          tags: item?.type === "newAss" ? item?.data1 : [item],
        }),
      );

      if (response?.payload?.status === true) {
        await getOwnerDetaildata();
        toast.dismiss();
        CommonToast({
          text: <>Tags assigned successfully. </>,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        setLoading(false);
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // Removes the requested tags and refreshes the displayed account details.
  const handleRemoveTags = async (item) => {
    setLoading(true);
    if (ownerAccountsRemoveTagsLoading) {
      setLoading(true);
    }

    try {
      let param = Array.isArray(item) ? item : [item];
      const response = await dispatch(
        ownerAccountsRemoveTag({ owner_id: [id], tags: param }),
      );

      if (response?.payload?.status === true) {
        await getOwnerDetaildata();
        toast.dismiss();
        CommonToast({
          text: "Tags unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };

  // Refreshes the connected balance and records its previous/current values.
  const handleRefresh = async (ownerid) => {
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(ownerid));
      if (response?.payload?.status == true) {
        setPrevConnectedBal(ownerDetailData?.owner_account_balance);
        setCurrentConnectedBal(
          response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
            ?.owner_account_balance,
        );

        setOwnerdetaildata((prevState) => {
          return {
            ...prevState,
            owner_account_balance_last_fetched_at_in_words:
              response?.payload?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance_last_fetched_at_in_words,
            owner_account_balance:
              response?.payload?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance,
            owner_account_balance_last_fetched_at:
              response.payload?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ].owner_account_balance_last_fetched_at,
            difference: Math.abs(
              Number(prevState.owner_account_balance) -
                Number(
                  response.payload.owner_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ].owner_account_balance,
                ),
            ),
            increaseOrDecrease:
              Number(prevState.owner_account_balance) >
              Number(
                response.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ].owner_account_balance,
              )
                ? "decreased"
                : Number(prevState.owner_account_balance) <
                    Number(
                      response.payload.owner_accounts[
                        GlobalConfiguration.lengthCheckZero
                      ].owner_account_balance,
                    )
                  ? "increased"
                  : "",
          };
        });
      } else {
        setTimeout(() => {
          toast.dismiss();

          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] ||
            response?.payload?.message ||
            "Something went wrong";

          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      throw error;
    }
  };

  // Adds or removes this account from favourites and updates local state.
  const handleFavourite = async () => {
    setIsFavLoading(true);
    showToast(
      isFavTagExist ? "Removing from favourite" : "Setting to favourite",
    );

    let res;
    if (isFavTagExist) {
      res = await dispatch(ownerAccountsRemoveFavourite(ownerDetailData.id));
      if (res?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Removed from favourite successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setIsFavTagExist(false);
        setFavShowPopup(false);
      }
    } else {
      res = await dispatch(ownerAccountsAddFavourite(ownerDetailData.id));
      if (res?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Favourite set successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setIsFavTagExist(true);
        setFavShowPopup(false);
      }
    }
    setIsFavLoading(false);
  };

  // Closes assigned-tag popup and restores the selected tag state.
  const handleCloseModal = () => {
    setViewstatementOpenPop(false);
    setSelectedTagOpenPop(false);
    setNewTags((prev) => {
      return [...prev].map((result) => {
        return { selected: true, value: result?.value, type: result?.type };
      });
    });
  };
  // Opens the selected-tag popup.
  const handleSelectedtag = () => {
    setSelectedTagOpenPop(true);
  };

  // Opens the statement popup.
  const handleViewStatement = () => {
    setViewstatementOpenPop(true);
  };

  // Switches the tab switcher to the details section.
  const toggleDetails = () => {
    setShowDetails(true);
    setShowStatistics(false);
    setShowAssignedTags(false);
  };

  // Switches the tab switcher to the statistics section and resets the report date range when entering it.
  const toggleStatistics = () => {
    setShowDetails(false);
    setShowStatistics(true);
    setShowAssignedTags(false);
    if (!showStatistics) {
      setStartDateState(
        new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
      );
      // setEndDateState(currentDate);
      setEndDateState(new Date());
      setStartDate(
        new Date(new Date().setDate(GlobalConfiguration?.lengthCheckOne)),
      );
      setEndDate(new Date());
    }
  };

  // Switches the tab switcher to the assigned-tag section.
  const toggleAdditionalDetails = () => {
    setShowAssignedTags(true);
    setShowStatistics(false);
    setShowDetails(false);
  };

  // Switches the tab switcher to the label section.
  const toggleLabelDetails = () => {
    setShowAssignedTags(false);
    setShowStatistics(false);
    setShowDetails(false);
  };

  // Converts backend account type names to the shorter UI labels.
  const accountType = (AccountType) => {
    switch (AccountType) {
      case "Overdraft Account":
        return "Overdraft (OD)";
      case "CACC":
        return "Cash credit (CC)";
      case "Current Account":
        return "Current account";
      case "Fixed Deposit Account":
        return "Fixed deposit (FD)";
      case "Salary Account":
        return "Salary account";
      default:
        return AccountType;
    }
  };

  // Opens assign label popup after checking archive, popup, and service access.
  const handleClick = () => {
    if (isArchived) return;
    if (
      props?.popType == "ownerStatement" ||
      props?.popType == "reimburseowner_details"
    ) {
      actionRestricted();
    } else if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  // Closes assign label popup and reloads details if a label action occurred.
  const handleClose = () => {
    setShowLabelsPopup(false);
    if (labelActionDispatchedRef.current) {
      getOwnerDetaildata();
    }
  };

  // Statistics Logic Start ---------------------------

  // Aligns weekly interest results with chart dates, filling gaps with zero.
  const handleWeekData = (weekData, pastSevenDates) => {
    const updatedData = [...missedIncomeGraphData];

    pastSevenDates.forEach((item, index) => {
      const specDate = new Date(item);

      // Find the matching week date
      const matchedWeekData = weekData.find((data) => {
        const weekDate = new Date(data?.date);
        return (
          specDate.getDate() === weekDate.getDate() &&
          specDate.getMonth() === weekDate.getMonth() &&
          specDate.getFullYear() === weekDate.getFullYear()
        );
      });

      // If a match is found, use its daily_interest, else 0
      if (matchedWeekData) {
        if (amountRangeValue !== "") {
          updatedData[index] = formatTotalBalance(
            matchedWeekData?.daily_interest,
            amountRangeValue,
          ).amount;
        } else {
          updatedData[index] = matchedWeekData?.daily_interest;
        }
      } else {
        updatedData[index] = GlobalConfiguration.lengthCheckZero;
      }
    });

    setMissedIncomeGraphData(updatedData);
  };

  // Fetches historical balance data and stores either the weekly or range report.
  const handleStatisticsData = async (
    start_Date,
    end_Date,
    interest_rate,
    type = "week",
  ) => {
    try {
      let reportData = [];

      const handleResponse = (response, isWeek) => {
        if (response?.payload?.status === true) {
          reportData =
            response?.payload?.owner_account_details?.account_balances_report;

          if (isWeek) {
            setAccountBalancesReportWeekData(reportData);
            setAccountBalancesReportWeekAllData(response?.payload);
          } else {
            setAccountBalancesReportData(reportData);
            setAccountBalancesReportAllData(response?.payload);
          }
        } else {
          const error =
            response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ];
          if (isWeek) {
            setAccountBalancesReportWeekData([]);
            setAccountBalancesReportWeekAllData([]);
            setAccountBalancesReportWeekError(error);
          } else {
            setAccountBalancesReportData([]);
            setAccountBalancesReportAllData([]);
            setAccountBalancesReportError(error);
          }
        }
      };

      let response;

      if (type !== "week") {
        response = await dispatch(
          ownerAccountsHistoricBalanceReport({
            id: id,
            start_date: start_Date,
            end_date: end_Date,
            // interest_rate: interest_rate,
          }),
        );
        handleResponse(response, false);
      } else {
        response = await dispatch(
          ownerAccountsHistoricBalanceReport({
            id: id,
            start_date: start_Date,
            end_date: end_Date,
            // interest_rate: interest_rate,
          }),
        );
        handleResponse(response, true);
      }

      if (type === "week") {
        handleWeekData(reportData, pastSevenDates);
      }
    } catch (error) {
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  // Applies the calendar's selected range to both report date pairs.
  const handleDateChange2 = (dates) => {
    const [start, end] = dates;
    setStartDateState(start);
    setEndDateState(end);

    setStartDate(start);
    setEndDate(end);
  };

  // Builds chart labels and date values for the previous seven days.
  function getPastSevenDaysDates() {
    // Six days ago
    const sixDaysAgo = new Date(currentDate);
    sixDaysAgo.setDate(
      currentDate.getDate() - GlobalConfiguration.lengthCheckSix,
    );

    const yesterdaysDate = new Date(currentDate);

    // Function to format the date in "23 Feb" format
    const formatDateDays = (date) => {
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "short" }); // Get short month name
      return `${day} ${month}`;
    };

    const pastSevenDays = [];
    const pastSevenDates = [];
    for (
      let i = GlobalConfiguration.lengthCheckZero;
      i < GlobalConfiguration.lengthCheckSeven;
      i++
    ) {
      const date = new Date(sixDaysAgo);
      date.setDate(sixDaysAgo.getDate() + i);
      pastSevenDays.push(formatDateDays(date));
      pastSevenDates.push(date);
    }

    return {
      sixDaysAgo: sixDaysAgo,
      yesterdaysDate: yesterdaysDate,
      pastSevenDays: pastSevenDays,
      pastSevenDates: pastSevenDates,
    };
  }

  // Reused date values for the weekly interest chart and report request.
  const { sixDaysAgo, yesterdaysDate, pastSevenDays, pastSevenDates } =
    getPastSevenDaysDates();

  // Opens statistics tab when the account has the required balance service access.
  const handleStatistics = () => {
    if (
      ownerDetailData?.connected_banking === "Y" &&
      (services?.includes("Admin") || services?.includes("VAccountBalance"))
    ) {
      toggleStatistics();
      if (showStatistics) {
        handleStatisticsData(
          formatDate(startDateState),
          formatDate(endDateState),
          investmentRateValue,
          "month",
        );

        handleStatisticsData(
          formatDate(sixDaysAgo),
          formatDate(yesterdaysDate),
          investmentRateValue,
          "week",
        );
      }
    } else if (
      ownerDetailData?.connected_banking === "Y" &&
      (!services?.includes("Admin") || !services?.includes("VAccountBalance"))
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VAccountBalance",
        },
      });
    }
  };

  // Statistics logic end ---------------------------

  // Saves the overdraft limit and updates the local account record on success.
  const handleCreditLimit = async () => {
    if (!creditLimitInput || creditLimitInput === initialCreditLimit)
      return false;

    setIsCreditLimitLoading(true);
    showToast("Setting credit limit");

    const res = await dispatch(
      updateOwnerDetailsById({
        id: ownerDetailData?.id,
        od_limit: creditLimitInput,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero],
      );
      const newCreditLimit = String(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
          ?.od_limit || "",
      );
      setInitialCreditLimit(newCreditLimit);
      toast.dismiss();
      CommonToast({
        text: "Credit limit set successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowCreditLimitPopup(false);
    } else if (res?.error) {
      const errorMessage =
        res?.payload?.response?.data?.errors?.od_limit?.[
          GlobalConfiguration.lengthCheckZero
        ] || "Currently unable to set credit limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsCreditLimitLoading(false);
    setShowCreditLimitPopup(false);
  };

  // Saves the minimum balance limit and updates the local account record.
  const handleMinimumLimit = async () => {
    if (!minimumLimitInput || minimumLimitInput === initialMinimumLimit)
      return false;

    const minLimit = Number(minimumLimitInput);

    setIsMinimumLimitLoading(true);
    showToast("Updating minimum balance");

    const res = await dispatch(
      updateOwnerDetailsById({
        id: ownerDetailData?.id,
        min_limit: minLimit,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero],
      );
      const newMinimumLimit = String(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
          ?.min_limit || "",
      );
      setInitialMinimumLimit(newMinimumLimit);
      toast.dismiss();
      CommonToast({
        text: "Updated minimum balance successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowMinimumLimitPopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.[GlobalConfiguration.lengthCheckZero] ||
        "Currently unable to set minimum limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsMinimumLimitLoading(false);
    setShowMinimumLimitPopup(false);
  };

  // Saves the auto-sweep maximum and updates the local account record.
  const handleMaximumLimit = async () => {
    if (!maximumLimitInput || maximumLimitInput === initialMaximumLimit)
      return false;

    const maxLimit = Number(maximumLimitInput);

    setIsMaximumLimitLoading(true);
    showToast("Updating auto sweep limit");

    const res = await dispatch(
      updateOwnerDetailsById({
        id: ownerDetailData?.id,
        max_limit: maxLimit,
      }),
    );
    if (res?.payload?.status) {
      setOwnerdetaildata(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero],
      );
      const newMaximumLimit = String(
        res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
          ?.max_limit || "",
      );
      setInitialMaximumLimit(newMaximumLimit);
      toast.dismiss();
      CommonToast({
        text: "Updated auto sweep limit",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setShowMaximumLimitPopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.[GlobalConfiguration.lengthCheckZero] ||
        "Currently unable to set minimum limit";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setIsMaximumLimitLoading(false);
    setShowMaximumLimitPopup(false);
  };

  // Clears transaction-type selection when the chooser closes.
  const handleTxnTypeModalClose = () => {
    setSelectedTxnTypeChipIndex("");
    setShowModal(false);
  };

  // Opens beneficiary history after checking popup restrictions and access.
  const handleOwnerBeneTxnHistory = () => {
    if (isOwnerPopupRestricted) {
      CommonToast({
        text: "Action restricted in popup mode.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      return;
    }

    if (!hasBeneTxnHistoryService) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VBeneficiaryTxn",
        },
      });
      return;
    }

    setOpenBeneHistory(true);
  };

  // Opens internal transaction history after checking restrictions and access.
  const handleOwnerInternalTxnHistory = () => {
    if (isOwnerPopupRestricted) {
      CommonToast({
        text: "Action restricted in popup mode.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      return;
    }

    if (!hasInternalTxnHistoryService) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "VInternalTxn",
        },
      });
      return;
    }

    setOpenHistory(true);
  };

  // Routes the selected transaction type to its corresponding history view.
  const handleTxnTypeConfirm = () => {
    if (!isTxnTypeSelected) return;

    if (selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckZero) {
      handleOwnerBeneTxnHistory();
    } else if (
      selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckOne
    ) {
      handleOwnerInternalTxnHistory();
    }

    handleTxnTypeModalClose();
  };

  // Saves the selected account type and updates the displayed account record.
  const handleAccountType = async () => {
    if (!isAccountTypeSelected) return;
    setAccountTypeLoading(true);
    showToast("Changing account type");
    const accountTypeMap = {
      1: "Current Account",
      2: "Overdraft Account",
      // 3: "Savings Account",
      // 4: "Salary Account",
      5: "Fixed Deposit Account",
      // 6: "Recurring Deposit Account",
      7: "CACC",
      // 8: "Other",
      // 9: "Export/Import account",  These are the extra fields as from design
      // 10: "Letter of credit (LC)",
      // 11: "Bank guarantee",
      // 12: "Escrow for M&A",
    };
    const selectedAccountType = accountTypeMap[selectedChipIndex];

    const res = await dispatch(
      updateOwnerDetailsById({
        id: ownerDetailData.id,
        type_of_account: selectedAccountType,
        od_limit:
          selectedAccountType === "Overdraft Account" ? "0.1" : undefined,
      }),
    );
    if (updateOwnerDetailsById.fulfilled.match(res)) {
      setOwnerdetaildata(
        res.payload.owner_accounts[GlobalConfiguration.lengthCheckZero],
      );

      toast.dismiss();
      CommonToast({
        text: "Account type changed successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      setShowAccountTypePopup(false);
    } else {
      const errorMessage =
        res?.payload?.errors?.type_of_account?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero] ||
        "Account type cannot be changed";

      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAccountTypeLoading(false);
    setSelectedChipIndex("");
    setShowAccountTypePopup(false);
  };

  // Assigns labels to this account and returns whether the request succeeded.
  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      ownerAccountsAddLabel({
        record_ids: toArray(ownerDetailData?.id),
        labels: labelsToAssign,
      }),
    );

    if (ownerAccountsAddLabel.fulfilled.match(res)) {
      getOwnerDetaildata();
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (ownerAccountsAddLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: res.payload,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (ownerAccountsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  // Removes labels from this account and returns whether the request succeeded.
  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      ownerAccountsRemoveLabel({
        record_ids: toArray(ownerDetailData?.id),
        labels: labelsToUnassign,
      }),
    );

    if (ownerAccountsRemoveLabel.fulfilled.match(res)) {
      getOwnerDetaildata();
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    if (ownerAccountsRemoveLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: res.payload,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (ownerAccountsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  // Entry arrays below provide the account details and option chips to the UI in the details tab.
  const bankDetailsEntries = [
    {
      heading: "Account holder name",
      content: ownerDetailData?.name,
      type: "text",
    },
    {
      heading: "Account type",
      content: accountType(ownerDetailData?.account_type),
      iconArray: [
        {
          type: "indicator",
          title:
            ownerDetailData?.connected_banking === "Y" ? "Active" : "Inactive",
          bgColor:
            ownerDetailData?.connected_banking === "Y"
              ? "var(--settled)"
              : "var(--failed)",
          imgColor:
            ownerDetailData?.connected_banking === "Y"
              ? "var(--positive-bg)"
              : "var(--negative-bg)",
        },
        {
          type: "image",
          title: "Edit",
          icon: ICONS.EDIT,
          isDisabled:
            ownerDetailData?.account_type === "Overdraft Account" ||
            !services?.includes("UAccount"),
          onClick: () => {
            if (!services?.includes("UAccount")) {
              navigate("/feature_not_assigned", {
                state: { unavailableService: "UAccount" },
              });
            } else if (ownerDetailData?.account_type === "CACC") {
              CommonToast({
                text: "Cash Credit account cannot be changed",
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                btnProps: {
                  isDisabled: false,
                  enabledTextColor: "var(--text-primary)",
                  enabledBgColor: "var(--primary-bg)",
                },
              });
            } else {
              setSelectedChipIndex("");
              setShowAccountTypePopup(
                ownerDetailData?.account_type !== "Overdraft Account" &&
                  ownerDetailData?.account_type !== "CACC",
              );
            }
          },
        },
      ],
      type: "textwithicon",
    },
  ];

  const ownerDetailsEntries = [
    {
      heading: TEXT?.PAN_NUMBER,
      content: ownerDetailData?.pan_no,
      type: "text",
      onClick: () => {
        if (
          props?.popType == "ownerStatement" ||
          props?.popType == "reimburseowner_details"
        ) {
          actionRestricted();
        } else if (services?.includes("VPAN")) {
          setPanShowPopup(true);
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "VPAN" },
          });
        }
      },
      isDisabled:
        props?.popType == "ownerStatement" ||
        props?.popType == "reimburseowner_details" ||
        !services?.includes("VPAN"),
    },
    {
      heading: TEXT?.GSTIN,
      content: ownerDetailData?.gstin_detail,
      type: "text",
      onClick: () => {
        if (
          props?.popType == "ownerStatement" ||
          props?.popType == "reimburseowner_details"
        ) {
          actionRestricted();
        } else if (services?.includes("VGSTIN")) {
          setGstShowPopup(true);
        } else {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "VGSTIN" },
          });
        }
      },
      isDisabled:
        props?.popType == "ownerStatement" ||
        props?.popType == "reimburseowner_details" ||
        !services?.includes("VGSTIN"),
    },
    // {
    //   heading: "Entity email ID",
    //   content: ownerDetailData?.email_id,
    //   type: "text",
    // },
  ];

  const supportDetailsEntries = [
    {
      heading: "Owner account ID",
      content: ownerDetailData?.id,
      type: "text",
    },
  ];

  const ownerTxnTypeChipsArray = [
    {
      text: "Beneficiary Transactions",
      imgUrl:
        "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg",
      selected:
        selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: !hasBeneTxnHistoryService,
      hoverOption: "blue",
      onClick: () => {
        if (!hasBeneTxnHistoryService) return;
        setSelectedTxnTypeChipIndex(
          selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckZero
            ? ""
            : GlobalConfiguration.lengthCheckZero,
        );
      },
    },
    {
      text: "Internal Transactions",
      imgUrl:
        "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
      selected: selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: !hasInternalTxnHistoryService,
      hoverOption: "blue",
      onClick: () => {
        if (!hasInternalTxnHistoryService) return;
        setSelectedTxnTypeChipIndex(
          selectedTxnTypeChipIndex === GlobalConfiguration.lengthCheckOne
            ? ""
            : GlobalConfiguration.lengthCheckOne,
        );
      },
    },
  ];

  const chipsArray = [
    {
      text: "Current account",
      disabled:
        ownerDetailData?.account_type === "Current Account" ||
        ownerDetailData?.account_type === "CACC",
      hoverOption: "blue",

      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckOne,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckOne),
    },
    {
      text: "Overdraft (OD)",
      disabled:
        ownerDetailData?.account_type === "Overdraft Account" ||
        ownerDetailData?.account_type === "CACC" ||
        (ownerDetailData?.account_type !== "Current Account" &&
          ownerDetailData?.account_type !== "Overdraft Account"),
      hoverOption: "blue",

      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckTwo,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
    },
    // {
    //   text: "Savings account",
    //   disabled:
    //     ownerDetailData?.account_type === "Savings Account" ? true : false,
    //   onClick: () => handleChipClick(3),
    //   selected: selectedChipIndex === 3,
    //   hoverOption: "white",
    // },
    // {
    //   text: "Salary account",
    //   disabled:
    //     ownerDetailData?.account_type === "Salary Account" ||
    //     (ownerDetailData?.account_type !== "Current Account" &&
    //       ownerDetailData?.account_type !== "Salary Account"),
    //   onClick: () => handleChipClick(4),
    //   selected: selectedChipIndex === 4,
    //   hoverOption: "white",
    // },

    // {
    //   text: "Recurring Deposit Account",
    //   disabled:
    //     ownerDetailData?.account_type === "Recurring Deposit Account"
    //       ? true
    //       : false,
    //   onClick: () => handleChipClick(6),
    //   selected: selectedChipIndex === 6,
    //   hoverOption: "white",
    // },
    {
      text: "Cash credit (CC)",
      disabled: ownerDetailData?.account_type === "CACC",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckSeven),
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckSeven,
      hoverOption: "blue",
    },
    {
      text: "Fixed deposit (FD)",
      disabled:
        ownerDetailData?.account_type === "Fixed Deposit Account" ||
        ownerDetailData?.account_type === "Current Account" ||
        ownerDetailData?.account_type !== "Fixed Deposit Account",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckFive),
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckFive,
      hoverOption: "blue",
    },
    // {
    //   text: "Other",
    //   disabled: ownerDetailData?.account_type === "Other" ? true : false,
    //   onClick: () => handleChipClick(8),
    //   selected: selectedChipIndex === 8,
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Escrow account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Nodal account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "EEFC account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Export/Import account",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Letter of credit (LC)",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Bank guarantee",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
    // {
    //   text: "Escrow for M&A",
    //   disabled: false,
    //   // onClick: () => handleChipClick(4),
    //   hoverOption: "blue",
    // },
  ];

  // Applies the slide direction whenever the selected carousel index changes.
  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  // Keeps limit form inputs in sync with the account's latest saved values.
  useEffect(() => {
    const currentLimit = ownerDetailData?.od_limit || "";
    const minCurrentLimit = ownerDetailData?.min_limit || "";
    const maxCurrentLimit = ownerDetailData?.max_limit || "";
    setMinimumLimitInput(String(minCurrentLimit));
    setInitialMinimumLimit(String(minCurrentLimit));
    setMaximumLimitInput(String(maxCurrentLimit));
    setInitialMaximumLimit(String(maxCurrentLimit));
    setCreditLimitInput(String(currentLimit));
    setInitialCreditLimit(String(currentLimit));
  }, [
    ownerDetailData?.od_limit,
    ownerDetailData?.min_limit,
    ownerDetailData?.max_limit,
  ]);

  // Loads weekly chart data whenever its rate or amount formatting changes.
  useEffect(() => {
    handleStatisticsData(
      formatDate(sixDaysAgo),
      formatDate(yesterdaysDate),
      investmentRateValue,
      "week",
    );
  }, [investmentRateValue, amountRangeValue]);

  // Refreshes the selected date-range report while statistics are visible.
  useEffect(() => {
    if (showStatistics) {
      handleStatisticsData(
        formatDate(startDateState),
        formatDate(endDateState),
        investmentRateValue,
        "month",
      );
    }
  }, [investmentRateValue, endDate, startDate, amountRangeValue]);

  // Loads the account's available labels when the account record changes.
  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsOwner");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [ownerDetailData?.id]);

  // Displays refresh progress and success feedback from Redux refresh state.
  useEffect(() => {
    if (ownerAccBalanceLoading && !openHistory) {
      UniversalRefreshToast();
    }

    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();

        if (showSuccessToast && !openHistory) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });

            dispatch(setshowsuccestoast());
          }, 250);
        }
      }, 500);
    }
  }, [ownerAccBalanceLoading]);

  // Loads account details on id changes and restores cached available tags.
  useEffect(() => {
    getOwnerDetaildata();
    if (
      ownerAccountAvailableTags?.length === GlobalConfiguration?.lengthCheckZero
    ) {
      const availableTags = sessionStorage.getItem("AvailableTags");
      if (availableTags) {
        dispatch(setTags(JSON.parse(availableTags, ...newTags)));
      }
    }
  }, [id]);

  // Dismisses the info popover on outside clicks and removes its listener.
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (infoRef.current && !infoRef.current.contains(event.target)) {
        setInfoState(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <>{RestrictedActionPopup}</>
      <div
        className={`${
          props?.popType == "reimburseowner_details" ||
          props?.popType == "ownerStatement"
            ? "h-full"
            : "h-full-height"
        } overflow-x-hidden`}
        style={{
          backgroundColor: "var(--primary-bg)",
          overflowY:
            viewStatementOpenPop || selectedTagOpenPop ? "hidden" : "auto",
        }}
      >
        {/* Popups start from here------------------- */}
        <div>
          {viewStatementOpenPop && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max  bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="View bank statement"
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setViewstatementOpenPop(false)}
                closeicon={ICONS?.CLOSE}
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                fullviewisDisabled={false}
                fullviewdisabledBgColor={""}
                isfullViewrequired={true}
                fullviewhandleFunction={() => {
                  setViewstatementOpenPop(false);
                  navigate(
                    `/owner_account_dashboard/consolidated_bank_statement/`,
                    {
                      state: {
                        startDate: bankStatementStartDate,
                        endDate: bankStatementEndDate,
                        ownerId: id,
                        type: "consolidatedFullView",
                      },
                    },
                  );
                }}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={true}
                isDisabled={false}
              >
                <OwnerAllStatement
                  popType={"remitterBankStatement"}
                  ownerDetailId={id}
                  flow={"ownerDetail"}
                  ownerDetailData={ownerDetailData}
                  setViewstatementOpenPop={setViewstatementOpenPop}
                />
              </LargePopupRedirect>
            </div>
          )}
          {viewItemisedOpenPop && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max  bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="View live statement"
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setViewItemisedOpenPop(false)}
                closeicon={ICONS?.CLOSE}
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                fullviewisDisabled={false}
                fullviewdisabledBgColor={""}
                isfullViewrequired={true}
                fullviewhandleFunction={() => {
                  setViewstatementOpenPop(false);
                  navigate(
                    `/owner_account_dashboard/consolidated_live_statement/`,
                    {
                      state: {
                        startDate: liveStatementStartDate,
                        endDate: liveStatementEndDate,
                        ownerId: id,
                        type: "consolidatedFullView",
                      },
                    },
                  );
                }}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={true}
                isDisabled={false}
              >
                <OwnerAccountItemisedReportComp
                  popType={"remitterBankStatement"}
                  ownerDetailId={id}
                  ownerDetailData={ownerDetailData}
                  flow={"ownerDetail"}
                  setViewItemisedOpenPop={setViewItemisedOpenPop}
                />
              </LargePopupRedirect>
            </div>
          )}
          {showLabelsPopup && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setShowLabelsPopup(true);
              }}
              className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
            >
              <CommonAssignLabelPopup
                headerTitle="Assign/unassign labels:"
                headersubtext="Labels will be used to generate statistics for the associated accounts."
                closehandleFunction={handleClose}
                closeisDisabled={false}
                labels={labels}
                setLabels={setLabels}
                LabelAccounts={ownerDetailData?.id}
                isLabelPopupOpen={showLabelsPopup}
                filteredData={ownerAccountsDetailData?.owner_accounts}
                labelActionDispatchedRef={labelActionDispatchedRef}
                onClose={handleClose}
                loading={loading}
                setLoading={setLoading}
                handleAssignLabels={handleAssignLabelsProp}
                handleUnassignLabels={handleUnassignLabelsProp}
                type="details"
              />
            </div>
          )}
          {openHistory && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="Internal transaction history "
                headersubtext="All transactions related to the owner account are listed below."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setOpenHistory(false)}
                closeicon={ICONS?.CLOSE}
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                confirmbtnrequired={true}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                isDisabled={false}
                isCreditDebitRequired={true}
                togglepan={() => {
                  setBalanceType("credit");
                }}
                toggleBank={() => {
                  setBalanceType("debit");
                }}
              >
                <InternalTransactionViewAll
                  onClose={() => setOpenHistory(false)}
                  txnHistorytype={"ownerDetailTxnHistory"}
                  owner_account_id={ownerDetailData?.id}
                  owner_account_bank_acc_no={ownerDetailData?.bank_acc_no}
                  OwnerDetail={true}
                  BeneAccId={
                    getAllInternalAccountData?.internal_accounts?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.id
                  }
                  internal_acc_name={ownerDetailData?.name}
                  balanceType={balanceType}
                  setBalanceType={setBalanceType}
                  typepop={"ownerDetailTxnHistoryPopUp"}
                />
              </LargePopupRedirect>
            </div>
          )}
          {openBeneHistory && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <LargePopupRedirect
                headerTitle="Beneficiary transaction history"
                headersubtext="All transactions related to the owner account are listed below."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => setOpenBeneHistory(false)}
                closeicon={ICONS?.CLOSE}
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                confirmbtnrequired={true}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"dark"}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                isDisabled={false}
              >
                <BeneficiaryTransactionViewall
                  onClose={() => setOpenBeneHistory(false)}
                  typepop={"txnHistorypopup"}
                  Owner_account_id={ownerDetailData?.id}
                  Owner_account_number={ownerDetailData?.bank_acc_no}
                  OwnerDetail={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {minBalance && (
            <div className="fixed w-width-full h-height-full flex items-center bg-Primary-black justify-center z-z-index-max bg-opacity-dark-opacity">
              <MinimumBal
                setMinBalance={setMinBalance}
                amount={amount}
                setAmount={setAmount}
              />
            </div>
          )}
          {selectedTagOpenPop && (
            <div
              className="fixed top-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-max"
              onClick={handleCloseModal}
            >
              {
                <CommonAssignTagPopup
                  headerTitle="Assign/Unassign tags:"
                  closehandleFunction={handleCloseModal}
                  closedisabledBgColor=""
                  closebuttonRef=""
                  closeimgColor=""
                  loading={loading}
                  newTags={newTags}
                  handleAddTags={handleAddTags}
                  existingTags={existingTags}
                  setExistingTags={setExistingTags}
                  handleRemoveTags={handleRemoveTags}
                  setNewTags={setNewTags}
                  ownerExistingTag={ownerDetailData?.tags}
                  AllTags={AllTags}
                  setAllTags={setAllTags}
                  setLoading={setLoading}
                  id={id}
                  ownerDetailData={ownerDetailData}
                  type={"ownerViewAll/ownerDetailPage"}
                />
              }
            </div>
          )}
          {showGstPopup && (
            <LargePopupRedirect
              headerTitle="GST Details"
              isfullViewrequired={true}
              fullviewhandleFunction={() =>
                navigate(`/settings/GST_verification`, {
                  state: ownerDetailData?.gstin_detail,
                })
              }
              closeiconhandleFunction={() => setGstShowPopup(false)}
            >
              <GSTVerification
                gst_number={ownerDetailData?.gstin_detail}
                popup={true}
              />
            </LargePopupRedirect>
          )}
          {showIfscPopup && (
            <div>
              <LargePopupRedirect
                headerTitle="IFSC Details"
                isfullViewrequired={true}
                fullviewhandleFunction={() =>
                  navigate(
                    `/settings/IFSC_verification/IFSC_Details/${ownerDetailData?.ifsc_code}`,
                  )
                }
                closeiconhandleFunction={() => setIfscShowPopup(false)}
              >
                <IFSCDetails
                  ifsc_code={ownerDetailData?.ifsc_code}
                  popup={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {showPanPopup && (
            <div>
              <LargePopupRedirect
                headerTitle="PAN Details"
                isfullViewrequired={true}
                fullviewhandleFunction={() =>
                  navigate(`/settings/PAN_verification`, {
                    state: ownerDetailData?.pan_no,
                  })
                }
                closeiconhandleFunction={() => setPanShowPopup(false)}
              >
                <PanVerification
                  pan_no={ownerDetailData?.pan_no}
                  popup={true}
                />
              </LargePopupRedirect>
            </div>
          )}
          {showFavPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithBulletPoint
                headerTitle={
                  isFavTagExist
                    ? "Remove from favourites"
                    : "Add to favourites "
                }
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                secondHeaderFontWeight="semibold"
                bulletPoints={
                  isFavTagExist
                    ? [
                        "It will no longer appear in the favourite section on dashboard.",
                        "Account will no longer be prioritized for statistics.",
                      ]
                    : [
                        "It will appear in the favourite section on dashboard.",
                        "Account will be prioritize for statistics.",
                      ]
                }
                isTextInputField={false}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setFavShowPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isFavLoading ? true : false}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText={isFavTagExist ? "Remove" : "Add"}
                btnTwoHandleFunction={handleFavourite}
                btnTwoEnabledBgColor={
                  isFavTagExist ? "var(--negative-act)" : "var(--positive-act)"
                }
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isFavLoading}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          {showCreditLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle={"Credit limit"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext={
                  "Specify the credit limit to be applied to this account."
                }
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setCreditLimitInput(value)}
                inputValue={creditLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowCreditLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isCreditLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText={
                  initialCreditLimit &&
                  Number(initialCreditLimit) >
                    GlobalConfiguration?.lengthCheckZero
                    ? "Update"
                    : "Confirm"
                }
                btnTwoHandleFunction={handleCreditLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !creditLimitInput.length ||
                  creditLimitInput === initialCreditLimit
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isCreditLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {showMinimumLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle={"Minimum balance"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                bulletPoints={[
                  "The minimum balance cannot exceed the auto-sweep limit.",
                ]}
                secondHeaderTitle={
                  "The required minimum balance to be maintained in this account and cannot be utilized for any transactions."
                }
                secondHeaderFontWeight="normal"
                secondHeaderTextSize="font-xs"
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setMinimumLimitInput(value)}
                inputValue={minimumLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowMinimumLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isMinimumLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText={
                  initialMinimumLimit &&
                  Number(initialMinimumLimit) >
                    GlobalConfiguration?.lengthCheckZero
                    ? "Update"
                    : "Confirm"
                }
                btnTwoHandleFunction={handleMinimumLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !minimumLimitInput.length ||
                  minimumLimitInput === initialMinimumLimit ||
                  Number(minimumLimitInput) > Number(maximumLimitInput)
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isMinimumLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {showMaximumLimitPopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <SmallPopupWithInput
                headerTitle="Auto sweep limit"
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                secondHeaderTitle={
                  "Enter the maximum balance limit for this account; balance exceeding this amount will be auto-swept to another account."
                }
                bulletPoints={[
                  "The auto-sweep limit cannot be lower than the minimum balance.",
                ]}
                secondHeaderFontWeight="normal"
                secondHeaderTextSize="font-xs"
                isTextInputField={true}
                inputPlaceholder="Amount"
                inputVariant="default"
                inputBgColor="var(--primary-bg)"
                inputFgColor="var(--text-secondary)"
                inputOnInput={(value) => setMaximumLimitInput(value)}
                inputValue={maximumLimitInput}
                inputFontKind="medium"
                inputIsFullWidth={true}
                btnOneText="Cancel"
                btnOneHandleFunction={() => setShowMaximumLimitPopup(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneIsDisabled={isMaximumLimitLoading}
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnTwoText={
                  initialMaximumLimit &&
                  Number(initialMaximumLimit) >
                    GlobalConfiguration?.lengthCheckZero
                    ? "Update"
                    : "Confirm"
                }
                btnTwoHandleFunction={handleMaximumLimit}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={
                  !maximumLimitInput.length ||
                  maximumLimitInput === initialMaximumLimit ||
                  Number(maximumLimitInput) < Number(minimumLimitInput)
                }
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={isMaximumLimitLoading}
                btnTwoHoverOption="black"
                inputType="amount"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnTwoInActiveVariantNeeded={true}
              />
            </div>
          )}
          {accountTypePopup && (
            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
              <EditCommonPopup
                btnOneHandleFunction={() => {
                  if (!accountTypeLoading) {
                    setSelectedChipIndex("");
                    setShowAccountTypePopup(false);
                  }
                }}
                subtext={"Available account types are listed below."}
                headerTitle="Select account type"
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                chipsArray={chipsArray}
                btnOneText="Cancel"
                btnOneEnabledBgColor="var(--primary-bg)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnOneIsDisabled={accountTypeLoading}
                btnOneOutLineColor="var(--text-primary)"
                btnTwoText="Confirm"
                btnTwoHandleFunction={handleAccountType}
                btnTwoIsDisabled={!isAccountTypeSelected || accountTypeLoading}
                btnTwoEnabledBgColor="var(--positive-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsLoaderNeeded={true}
                btnTwoIsLoading={accountTypeLoading}
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoDisabledTextColor="var(--text-primary)"
                btnTwoHoverOption="black"
                btnOneBtnType="button"
                btnTwoBtnType="button"
                btnOneInActiveVariantNeeded={true}
                btnTwoInActiveVariantNeeded={true}
                defaultHeight={isAccountTypeSelected ? selectedChipIndex : null}
                activeAccountType={true}
              />
            </div>
          )}
          {infoAmountPopup && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <CommonInfoBox
                rows={[
                  {
                    label: "Balance",
                    value: ownerDetailData?.owner_account_balance,
                    icon: ICONS?.PLUS_WHITE,
                  },
                  {
                    label: "Credit limit",
                    value:
                      ownerDetailData?.od_limit ||
                      GlobalConfiguration.lengthCheckZero,
                    operation: "add",
                  },
                ]}
                headerTitle={"Amount Breakdown"}
                headerFontColor={"text-primary"}
                textSize={"font-md"}
                popupBgColor={"primary-bg"}
                transactionLabel={"Available balance"}
                finalAmountLabel={"Available balance"}
                transactionAmount={ownerDetailData?.owner_account_balance}
                onClosepop={() => setInfoAmountPopup(false)}
              />
            </div>
          )}
        </div>
        {/* Popups end here------------------- */}

        {/*Header for web app and mobile starts here */}
        <div
          className="w-width-full flex Qsmd:hidden fixed z-z-index-fixed-ui items-center bg-primary-nav-act justify-between"
          style={{
            display:
              props?.popType == "ownerStatement" ||
              props?.popType == "reimburseowner_details" ||
              openHistory
                ? "none"
                : "",
          }}
        >
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader={"Owner"}
            topNavSubText="Account details"
          />
        </div>
        {/*Header for web app and mobile ends here */}

        {loading || !ownerDetailData ? (
          <div className="owner-loader-container justify-center items-center flex h-full-height">
            <Loader />
          </div>
        ) : (
          <>
            <div
              style={{
                marginTop:
                  props?.popType == "ownerStatement" ||
                  props?.popType == "reimburseowner_details"
                    ? "var(--margin-base)"
                    : "var(--navbar-height)",
                paddingTop: "var(--padding-base)",
              }}
              className={` ${props?.popType == "reimburseowner_details" ? " w-full" : "content-page"}  relative`}
            >
              <div className="ownerDetail-container ">
                <div className="acc-section">
                  <div
                    className={`${props?.popType == "reimburseowner_details" ? " w-full mx-margin-base Qsmd:mx-margin-sm" : props.popType !== "ownerStatement" ? "major-div mx-margin-base Qsmd:mx-margin-sm" : "w-width-full  mt-margin-base "}`}
                  >
                    <div
                      className={`individual-bank-detail ${props?.popType == "reimburseowner_details" ? "" : "pt-padding-base"}  Qsmd:pt-padding-base mt-margin-base Qsmd:mt-[var(--borderthickness)] px-padding-md Qsmd:px-padding-base w-auto Qlg:w-width-full `}
                    >
                      <div
                        className={`${props.popType !== "ownerStatement" ? "individual-account  Qlg:pt-padding-sm justify-center  mt-margin-base" : "individual-account mt-margin-base"}`}
                      >
                        {ownerDetailData?.owner_account_balance ? (
                          <div className="acc-balance-content">
                            <div
                              className="refresh-amt-div text-font-md relative"
                              style={{
                                fontWeight: "var(--font-semibold)",
                                color:
                                  ownerDetailData?.owner_account_balance !==
                                    null &&
                                  ownerDetailData?.owner_account_balance !==
                                    undefined &&
                                  (ownerDetailData?.owner_account_balance ===
                                    "xxxx.xx" ||
                                    Number.isNaN(
                                      Number(
                                        ownerDetailData?.owner_account_balance,
                                      ),
                                    ) ||
                                    Number(
                                      ownerDetailData?.owner_account_balance,
                                    ) >= GlobalConfiguration?.lengthCheckZero)
                                    ? "var(--settled)"
                                    : "var(--failed)",
                                paddingRight: "var(--padding-md)",
                              }}
                            >
                              {shouldBeRedacted(
                                ownerDetailData?.owner_account_balance,
                              )
                                ? ""
                                : "INR "}
                              {
                                formatTotalBalance(
                                  Number(
                                    ownerDetailData?.owner_account_balance,
                                  ) +
                                    Number(
                                      ownerDetailData?.od_limit ||
                                        GlobalConfiguration.lengthCheckZero,
                                    ),
                                ).amount
                              }
                              <div
                                style={{
                                  display:
                                    services?.includes("VAccountBalance") ||
                                    services?.includes("Admin")
                                      ? "flex"
                                      : "none",
                                }}
                                className="absolute bottom-[var(--padding-button-l)] right-top_xxs "
                              >
                                <img
                                  src={ICONS?.INFO}
                                  className="w-icon-sm h-icon-sm cursor-pointer"
                                  onClick={() => setInfoAmountPopup(true)}
                                />
                              </div>
                            </div>
                            {ownerDetailData?.connected_banking === "Y" &&
                            !ownerAccBalanceLoading ? (
                              Number(currentConnectedBal) >
                              Number(prevConnectedBal) ? (
                                <span className="mx-top_xs">
                                  <img
                                    className="h-icon-md w-icon-md"
                                    src={ICONS?.ARROW_UP_GREEN_GIF}
                                    alt=""
                                  />
                                </span>
                              ) : Number(currentConnectedBal) <
                                Number(prevConnectedBal) ? (
                                <span className="mx-top_xs">
                                  <img
                                    className="h-icon-md w-icon-md"
                                    src={ICONS?.ARROW_DOWN_RED_GIF}
                                    alt=""
                                  />
                                </span>
                              ) : undefined
                            ) : undefined}
                            {ownerDetailData?.connected_banking === "Y" && (
                              <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                            )}

                            {ownerDetailData?.connected_banking === "Y" && (
                              <div className="refresh-div">
                                {ownerAccBalanceLoading &&
                                !ownerAccBalanceError &&
                                accId === ownerDetailData?.id ? (
                                  <BalanceLoader
                                    ownerDetails="BalanceownerDetails"
                                    loader={ownerAccBalanceLoading}
                                  />
                                ) : !ownerAccBalanceLoading &&
                                  accId === ownerDetailData?.id ? (
                                  <BalanceLoader
                                    loader={ownerAccBalanceLoading}
                                    setAccId={setAccId}
                                    ownerDetails="BalanceownerDetails"
                                  />
                                ) : (
                                  <CardActionableButton
                                    btnType="button"
                                    handleFunction={(e) => {
                                      if (
                                        services?.includes("VAccountBalance") ||
                                        services?.includes("Admin")
                                      ) {
                                        if (
                                          ownerDetailData?.connected_banking ===
                                          "Y"
                                        ) {
                                          setAccId(ownerDetailData?.id);
                                          handleRefresh(ownerDetailData?.id);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: [
                                              "VAccountBalance",
                                              "Admin",
                                            ],
                                          },
                                        });
                                      }
                                    }}
                                    isDisabled={
                                      ensureAll(["VAccountBalance"]).status ||
                                      ensureAll(["Admin"]).status
                                        ? false
                                        : true
                                    }
                                    disabledBgColor="var(--primary-nav-act)"
                                    icon={ICONS?.RELOAD_REFRESH_WHITE}
                                    hoverOption="white"
                                    title="Refresh"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="acc-balance-content">
                            <div>N/A</div>
                          </div>
                        )}
                        <div className="acc-number-balance w-auto">
                          Available balance
                        </div>
                      </div>
                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                      <div className="w-width-full Qsmd:w-tl-width-2  flex justify-between border-t-border border-t-primary-bg Qlg:border-b-border-base border-b-border border-b-primary-bg  Qsmd:border-none Qsmd:h-auto Qlg:pl-padding-md Qsmd:pl-padding-base">
                        <div className="owner-details-acc-balance  Qsmd:mr-margin-md Qsmd:pl-padding-md Qlg:pl-padding-base">
                          {ownerDetailData?.owner_account_balance ? (
                            <div className="acc-balance-content">
                              <div
                                className=" refresh-amt-div text-font-md"
                                style={{
                                  fontWeight: "var(--font-semibold)",
                                  color:
                                    ownerDetailData?.owner_account_balance !==
                                      null &&
                                    ownerDetailData?.owner_account_balance !==
                                      undefined &&
                                    (ownerDetailData?.owner_account_balance ===
                                      "xxxx.xx" ||
                                      Number.isNaN(
                                        Number(
                                          ownerDetailData?.owner_account_balance,
                                        ),
                                      ) ||
                                      Number(
                                        ownerDetailData?.owner_account_balance,
                                      ) >= GlobalConfiguration?.lengthCheckZero)
                                      ? "var(--settled)"
                                      : "var(--failed)",
                                  paddingRight: "var(--padding-sm)",
                                  borderRight:
                                    ownerDetailData?.connected_banking ===
                                      "Y" &&
                                    "var(--border) solid var(--primary-bg)",
                                }}
                              >
                                {shouldBeRedacted(
                                  ownerDetailData?.owner_account_balance,
                                )
                                  ? ""
                                  : "INR "}
                                {
                                  formatTotalBalance(
                                    Number(
                                      ownerDetailData?.owner_account_balance,
                                    ),
                                  ).amount
                                }
                                <span className="ml-top_xs">
                                  {ownerDetailData?.connected_banking === "Y" &&
                                  !ownerAccBalanceLoading ? (
                                    Number(currentConnectedBal) >
                                    Number(prevConnectedBal) ? (
                                      <img
                                        className="h-icon-md w-icon-md"
                                        src={ICONS?.ARROW_UP_GREEN_GIF}
                                        alt=""
                                      />
                                    ) : Number(currentConnectedBal) <
                                      Number(prevConnectedBal) ? (
                                      <img
                                        className="h-icon-md w-icon-md"
                                        src={ICONS?.ARROW_DOWN_RED_GIF}
                                        alt=""
                                      />
                                    ) : undefined
                                  ) : undefined}
                                </span>
                              </div>
                              {ownerDetailData?.connected_banking === "Y" && (
                                <div className="refresh-div">
                                  {ownerAccBalanceLoading &&
                                  !ownerAccBalanceError &&
                                  accId === ownerDetailData?.id ? (
                                    <BalanceLoader
                                      ownerDetails="BalanceownerDetails"
                                      loader={ownerAccBalanceLoading}
                                    />
                                  ) : !ownerAccBalanceLoading &&
                                    accId === ownerDetailData?.id ? (
                                    <BalanceLoader
                                      loader={ownerAccBalanceLoading}
                                      setAccId={setAccId}
                                      ownerDetails="BalanceownerDetails"
                                    />
                                  ) : (
                                    <CardActionableButton
                                      btnType="button"
                                      handleFunction={(e) => {
                                        if (
                                          services?.includes(
                                            "VAccountBalance",
                                          ) ||
                                          services?.includes("Admin")
                                        ) {
                                          if (
                                            ownerDetailData?.connected_banking ===
                                            "Y"
                                          ) {
                                            setAccId(ownerDetailData?.id);
                                            handleRefresh(ownerDetailData?.id);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: [
                                                "VAccountBalance",
                                                "Admin",
                                              ],
                                            },
                                          });
                                        }
                                      }}
                                      isDisabled={
                                        ensureAll(["VAccountBalance"]).status ||
                                        ensureAll(["Admin"]).status
                                          ? false
                                          : true
                                      }
                                      disabledBgColor="var(--primary-nav-act)"
                                      icon={ICONS?.RELOAD_REFRESH_WHITE}
                                      hoverOption="white"
                                      title="Refresh"
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="acc-balance-content">
                              <div>N/A</div>
                            </div>
                          )}
                          <div className="acc-number-balance w-auto">
                            {ownerDetailData?.owner_account_balance ? (
                              formatTotalBalance(
                                Number(ownerDetailData?.owner_account_balance),
                              ).prefix == "crores" ? (
                                <p>
                                  Balance - In crores{" "}
                                  {(ownerDetailData?.connected_banking ===
                                    "Y" ||
                                    "N") &&
                                  ownerDetailData?.active_status !== "Y"
                                    ? `- updated  ${ownerDetailData?.owner_account_balance_last_fetched_at_in_words}`
                                    : null}
                                </p>
                              ) : (
                                <p>
                                  Balance - updated{" "}
                                  {
                                    ownerDetailData?.owner_account_balance_last_fetched_at_in_words
                                  }
                                </p>
                              )
                            ) : (
                              <>
                                <p>Balance </p>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="statement-view-acc flex-row hidden Qsmd:flex bg-primary-nav-act">
                          <div className=""></div>
                          <TopNavSmallButton
                            btnText={
                              <>
                                {" "}
                                {globalText.BANK}
                                <br />
                                {globalText.STATEMENT}
                              </>
                            }
                            btnType="button"
                            imgColor="var(--text-primary)"
                            icon={ICONS?.VIEW_STATEMENT}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            hoverOption="white"
                            fullWidthRequired={false}
                            isLoading={false}
                            isDisabled={
                              props?.popType === "ownerStatement" ||
                              props?.popType == "reimburseowner_details" ||
                              (!services?.includes("VAccountBalance") &&
                                !services?.includes("Admin")) ||
                              ownerDetailData?.connected_banking !== "Y"
                            }
                            handleFunction={() => {
                              if (
                                props?.popType === "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                actionRestricted();
                              } else if (
                                props?.popType !== "ownerStatement" &&
                                (services?.includes("VAccountBalance") ||
                                  services?.includes("Admin")) &&
                                ownerDetailData?.connected_banking === "Y"
                              ) {
                                handleViewStatement();
                              } else if (
                                !services?.includes("VAccountBalance") &&
                                !services?.includes("Admin")
                              ) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "VAccountBalance,Admin",
                                  },
                                });
                              }
                            }}
                          />
                          <div className="ownerdetail-border-div hidden Qsmd:block"></div>
                          <TopNavSmallButton
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={
                              props?.popType === "ownerStatement" ||
                              props?.popType == "reimburseowner_details" ||
                              (!services?.includes("VItemisedStatement") &&
                                !services?.includes("Admin")) ||
                              ownerDetailData?.connected_banking !== "Y"
                            }
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                actionRestricted();
                              } else {
                                if (
                                  (services?.includes("VItemisedStatement") ||
                                    services?.includes("Admin")) &&
                                  ownerDetailData?.connected_banking === "Y"
                                ) {
                                  setViewItemisedOpenPop(true);
                                } else if (
                                  !services?.includes("VItemisedStatement") &&
                                  !services?.includes("Admin")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VItemisedStatement ",
                                    },
                                  });
                                }
                              }
                            }}
                            icon={ICONS?.LIVE_STATEMENT}
                            btnText={
                              <>
                                {" "}
                                Live <br />
                                statement
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="acc-status-main Qsmd:flex  w-width-full px-padding-md Qsmd:px-padding-base">
                      <div className="flex flex-1">
                        <div className="individual-account !pt-padding-md Qsmd:pt-padding-lg justify-center mt-margin-base">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type ===
                              "Overdraft Account" &&
                            ownerDetailData?.od_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.od_limit,
                                  })}
                                </div>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setCreditLimitInput(
                                      ownerDetailData?.od_limit ||
                                        GlobalConfiguration?.lengthCheckZero,
                                    );
                                    setShowCreditLimitPopup(true);
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={ICONS?.EDIT}
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                    title="Edit"
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>
                          <div className="acc-number-balance">Credit limit</div>
                        </div>
                      </div>
                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>

                      <div className="w-width-full Qsmd:w-tl-width-2 flex Qsmd:flex-row flex-col justify-between border-t-border border-t-primary-bg Qsmd:border-none Qsmd:h-auto">
                        <div className="flex flex-col  pl-padding-base py-padding-md Qsmd:pl-padding-md Qsmd:py-padding-base  p-padding-md w-width-full justify-center border-primary-bg border-b-border Qsmd:border-none">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type !==
                              "Overdraft Account" &&
                            ownerDetailData?.min_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.min_limit,
                                  })}
                                </div>
                                <div
                                  className={` ${props?.popType === "reimburseowner_details" || props?.popType === "ownerStatement" ? " cursor-not-allowed opacity-light-opacity" : "cursor-pointer"}`}
                                  onClick={() => {
                                    if (
                                      props?.popType ==
                                        "reimburseowner_details" ||
                                      props?.popType === "ownerStatement"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      setMinimumLimitInput(
                                        ownerDetailData?.min_limit ||
                                          GlobalConfiguration.lengthCheckZero,
                                      );
                                      setShowMinimumLimitPopup(true);
                                    }
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={ICONS?.EDIT}
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                    title="Edit"
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>

                          <div className="acc-number-label">
                            Minimum balance
                          </div>
                        </div>
                        <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                        <div className="flex flex-col pl-padding-base py-padding-md Qsmd:pl-padding-md Qsmd:py-padding-base  p-padding-md w-width-full justify-center">
                          <div className="flex gap-gap-sm items-center">
                            {ownerDetailData?.account_type !==
                              "Overdraft Account" &&
                            ownerDetailData?.max_limit ? (
                              <>
                                <div
                                  className={`text-font-md font-normal text-text-primary`}
                                >
                                  INR{" "}
                                  {FormatAmount({
                                    price: ownerDetailData?.max_limit,
                                  })}
                                </div>
                                <div
                                  className={` ${props?.popType === "reimburseowner_details" || props?.popType === "ownerStatement" ? " cursor-not-allowed opacity-light-opacity" : "cursor-pointer"}`}
                                  onClick={() => {
                                    if (
                                      props?.popType ==
                                        "reimburseowner_details" ||
                                      props?.popType === "ownerStatement"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      setMaximumLimitInput(
                                        ownerDetailData?.max_limit ||
                                          GlobalConfiguration.lengthCheckZero,
                                      );
                                      setShowMaximumLimitPopup(true);
                                    }
                                  }}
                                  disabled={!services?.includes("UAccount")}
                                >
                                  <img
                                    src={ICONS?.EDIT}
                                    className="w-icon-sm h-icon-sm"
                                    alt={"edit"}
                                    title="Edit"
                                  />
                                </div>
                              </>
                            ) : (
                              <div className="acc-balance-content">
                                <div>N/A</div>
                              </div>
                            )}
                          </div>

                          <div className="acc-number-label">
                            Auto sweep limit
                          </div>
                        </div>
                        <div className="statement flex bg-primary-nav-act">
                          <div className="hidden Qsmd:block">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  {" "}
                                  {globalText.TRANSACTION}
                                  <br />
                                  {globalText.HISTORY.toLowerCase()}
                                </>
                              }
                              btnType="button"
                              handleFunction={() => {
                                if (
                                  props?.popType === "ownerStatement" ||
                                  props?.popType == "reimburseowner_details"
                                ) {
                                  actionRestricted();
                                } else if (
                                  !services?.includes("VBeneficiaryTxn") &&
                                  !services?.includes("VInternalTxn")
                                ) {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "VBeneficiaryTxn,VInternalTxn",
                                    },
                                  });
                                } else {
                                  setSelectedTxnTypeChipIndex("");
                                  setShowModal(true);
                                }
                              }}
                              isDisabled={
                                props?.popType === "ownerStatement" ||
                                props?.popType == "reimburseowner_details" ||
                                (!services?.includes("VBeneficiaryTxn") &&
                                  !services?.includes("VInternalTxn"))
                              }
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              isLoading={false}
                              icon={ICONS?.TRANSACTION_HISTORY}
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                          <div className="ownerdetail-border-div hidden Qsmd:block"></div>{" "}
                          <div className=" hidden Qsmd:block bg-primary-nav-act w-width-md-2-3 h-height-full">
                            <div className="flex h-height-full">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {globalText.LINKED_INTERNAL}
                                    <br />
                                    {globalText.ACCOUNT}
                                  </>
                                }
                                btnType="button"
                                handleFunction={() => {
                                  if (
                                    props?.popType ==
                                      "reimburseowner_details" ||
                                    props?.popType === "ownerStatement"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    if (
                                      services?.includes("IVAccount") ||
                                      services?.includes("Admin")
                                    ) {
                                      if (
                                        getAllInternalAccountData
                                          ?.internal_accounts?.[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.id
                                      ) {
                                        navigate(
                                          `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${getAllInternalAccountData?.internal_accounts?.[GlobalConfiguration.lengthCheckZero]?.id}`,
                                        );
                                      } else {
                                        CommonToast({
                                          text: "Unable to get Id",
                                          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                          variant: "var(--error)",
                                          btnProps: {
                                            isDisabled: false,
                                            enabledTextColor:
                                              "var(--text-primary)",
                                            enabledBgColor: "var(--primary-bg)",
                                          },
                                        });
                                      }
                                    } else if (
                                      !services?.includes("IVAccount") &&
                                      !services?.includes("Admin")
                                    ) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IVAccount,Admin",
                                        },
                                      });
                                    }
                                  }
                                }}
                                isDisabled={
                                  props?.popType === "ownerStatement" ||
                                  props?.popType == "reimburseowner_details" ||
                                  (!services?.includes("IVAccount") &&
                                    !services?.includes("Admin"))
                                }
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                isLoading={false}
                                icon={ICONS?.LINKED_WHITE_CIRCLE}
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            </div>
                          </div>
                          {showModal && (
                            <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
                              <EditCommonPopup
                                headerTitle="Select transaction type"
                                subtext="Only transactions for the selected option will be displayed"
                                chipsArray={ownerTxnTypeChipsArray}
                                btnOneBtnType="button"
                                btnOneHandleFunction={handleTxnTypeModalClose}
                                btnOneEnabledBgColor="var(--primary-bg)"
                                btnOneEnabledTextColor="var(--text-primary)"
                                btnOneHoverOption="white"
                                btnOneOutLineColor="var(--text-primary)"
                                btnTwoText="Confirm"
                                btnTwoBtnType="button"
                                btnTwoHandleFunction={handleTxnTypeConfirm}
                                btnTwoIsDisabled={!isTxnTypeSelected}
                                btnTwoDisabledTextColor="var(--text-primary)"
                                btnTwoEnabledBgColor="var(--positive-act)"
                                btnTwoEnabledTextColor="var(--text-primary)"
                                btnTwoDisabledBgColor="var(--text-disabled)"
                                btnTwoInActiveVariantNeeded={true}
                                btnTwoHoverOption="black"
                                defaultHeight={
                                  isTxnTypeSelected
                                    ? selectedTxnTypeChipIndex
                                    : null
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="bank-details flex-col Qsmd:flex-row  Qsmd:px-padding-base">
                      <div className="accno-details pl-padding-base  items-center Qsmd:pl-padding-base justify-between Qsmd:border-t-border-base border-t-border border-t-primary-bg border-b-border border-b-primary-bg Qsmd:border-border-base mx-margin-md Qsmd:mx-margin-base">
                        <TitleSubtitlePair
                          title={formatAccountNumber(
                            ownerDetailData?.bank_acc_no,
                          )}
                          subtitle="Account number"
                          variant="md"
                          titleColor="text-primary"
                        />
                        <div className="Qsmd:pr-padding-md">
                          <CardActionableButton
                            isDisabled={
                              !services?.includes("AFavourite") ||
                              props?.popType == "ownerStatement" ||
                              props?.popType == "reimburseowner_details"
                            }
                            bgColor="var(--primary-bg)"
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                actionRestricted();
                                return;
                              }
                              if (!services?.includes("AFavourite")) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "AFavourite",
                                  },
                                });
                                return;
                              } else if (!isFavTagExist) {
                                setFavShowPopup(true);

                                return;
                              } else if (isFavTagExist) {
                                setFavShowPopup(true);
                                return;
                              }
                            }}
                            icon={
                              isFavTagExist
                                ? ICONS?.FAVOURITE_FILLED
                                : ICONS?.FAVOURITE
                            }
                            title="Favourites"
                          />
                        </div>
                      </div>

                      <div className="hidden Qsmd:flex border-primary-bg border-l-border my-margin-md h-auto"></div>
                      <div className="flex Qsmd:w-tl-width-2 gap-x-gap-xl ">
                        <div
                          className={`owner-div-main flex flex-row  items-center border-primary-bg Qsmd:border-none Qsmd:py-padding-sm Qsmd:px-padding-sm justify-between  Qsmd:pl-padding-sm py-padding-sm Qlg:p-padding-base pr-padding-sm  Qlg:pl-padding-sm Qsmd:pr-padding-base mx-margin-sm Qsmd:mx-margin-base `}
                        >
                          <div
                            className={` ${props?.popType == "reimburseowner_details" && "opacity-light-opacity"}`}
                          >
                            {" "}
                            <TitleSubtitlePair
                              title={ownerDetailData?.ifsc_code}
                              subtitle="IFSC"
                              showArrow={true}
                              isDisabled={
                                props?.popType == "reimburseowner_details" ||
                                props?.popType === "ownerStatement"
                                  ? true
                                  : false
                              }
                              hoverOption="white"
                              onClick={() => {
                                if (
                                  props?.popType == "ownerStatement" ||
                                  props?.popType == "reimburseowner_details"
                                ) {
                                  actionRestricted();
                                } else if (services?.includes("VIFSC")) {
                                  setIfscShowPopup(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VIFSC",
                                    },
                                  });
                                }
                              }}
                              variant="md"
                              titleColor="text-primary"
                            />
                          </div>

                          <div className="h-[fit-content]">
                            <CommonBankLogo
                              ifsc={ownerDetailData?.ifsc_code}
                              variant="big"
                              type="pill"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" bg-primary-card flex Qsmd:hidden"> </div>
              <div className="text-font-sm w-width-full bg-primary-card text-left flex Qsmd:hidden text-text-primary font-semibold px-padding-md py-padding-sm border-b-border border-primary-bg">
                Quick Actions
              </div>
              <div className="w-width-full border-b-border border-primary-bg"></div>
              <div className="w-width-full flex Qsmd:hidden border-b-border border-primary-bg">
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      {globalText.BANK}
                      <br />
                      {globalText.STATEMENT}
                    </>
                  }
                  btnType="button"
                  imgColor="var(--text-primary)"
                  icon={ICONS?.VIEW_STATEMENT}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  hoverOption="white"
                  fullWidthRequired={true}
                  isLoading={false}
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VAccountBalance") &&
                      !services?.includes("Admin")) ||
                    ownerDetailData?.connected_banking !== "Y"
                  }
                  handleFunction={() => {
                    if (
                      props?.popType === "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      actionRestricted();
                    } else if (
                      props?.popType !== "ownerStatement" &&
                      (services?.includes("VAccountBalance") ||
                        services?.includes("Admin")) &&
                      ownerDetailData?.connected_banking === "Y"
                    ) {
                      handleViewStatement();
                    } else if (
                      !services?.includes("VAccountBalance") &&
                      !services?.includes("Admin")
                    ) {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VAccountBalance,Admin",
                        },
                      });
                    }
                  }}
                />
                <div className="ownerdetail-border-div"></div>{" "}
                <TopNavSmallButton
                  fullWidthRequired={true}
                  enabledBgColor={"var(--primary-card)"}
                  enabledTextColor={"var(--text-primary)"}
                  hoverOption="white"
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VItemisedStatement") &&
                      !services?.includes("Admin")) ||
                    ownerDetailData?.connected_banking !== "Y"
                  }
                  handleFunction={() => {
                    if (
                      props?.popType == "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      actionRestricted();
                    } else {
                      if (
                        (services?.includes("VItemisedStatement") ||
                          services?.includes("Admin")) &&
                        ownerDetailData?.connected_banking === "Y"
                      ) {
                        setViewItemisedOpenPop(true);
                      } else if (
                        !services?.includes("VItemisedStatement") &&
                        !services?.includes("Admin")
                      ) {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "VItemisedStatement ",
                          },
                        });
                      }
                    }
                  }}
                  icon={ICONS?.LIVE_STATEMENT}
                  btnText={
                    <>
                      {" "}
                      {globalText.LIVE}
                      <br />
                      {globalText.STATEMENT}
                    </>
                  }
                />
              </div>

              <div className="w-auto flex Qsmd:hidden border-b border-primary-bg">
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      {globalText.TRANSACTION}
                      <br />
                      {globalText.HISTORY.toLowerCase()}
                    </>
                  }
                  btnType="button"
                  handleFunction={() => {
                    if (
                      props?.popType === "ownerStatement" ||
                      props?.popType == "reimburseowner_details"
                    ) {
                      actionRestricted();
                    } else if (
                      !services?.includes("VBeneficiaryTxn") &&
                      !services?.includes("VInternalTxn")
                    ) {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VBeneficiaryTxn,VInternalTxn",
                        },
                      });
                    } else {
                      setSelectedTxnTypeChipIndex("");
                      setShowModal(true);
                    }
                  }}
                  isDisabled={
                    props?.popType === "ownerStatement" ||
                    props?.popType == "reimburseowner_details" ||
                    (!services?.includes("VBeneficiaryTxn") &&
                      !services?.includes("VInternalTxn"))
                  }
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  isLoading={false}
                  icon={ICONS?.TRANSACTION_HISTORY}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
                <div className="ownerdetail-border-div"></div>{" "}
                <TopNavSmallButton
                  btnText={
                    <>
                      {" "}
                      {globalText.LINKED_INTERNAL}
                      <br />
                      {globalText.ACCOUNT}
                    </>
                  }
                  btnType="button"
                  handleFunction={() => {
                    if (
                      props?.popType == "reimburseowner_details" ||
                      props?.popType === "ownerStatement"
                    ) {
                      actionRestricted();
                    } else {
                      if (
                        services?.includes("IVAccount") ||
                        services?.includes("Admin")
                      ) {
                        if (
                          getAllInternalAccountData?.internal_accounts?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.id
                        ) {
                          navigate(
                            `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${getAllInternalAccountData?.internal_accounts?.[GlobalConfiguration.lengthCheckZero]?.id}`,
                          );
                        } else {
                          CommonToast({
                            text: "Unable to get Id",
                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                            variant: "var(--error)",
                            btnProps: {
                              isDisabled: false,
                              enabledTextColor: "var(--text-primary)",
                              enabledBgColor: "var(--primary-bg)",
                            },
                          });
                        }
                      } else if (
                        !services?.includes("IVAccount") &&
                        !services?.includes("Admin")
                      ) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "IVAccount,Admin" },
                        });
                      }
                    }
                  }}
                  isDisabled={
                    props?.popType == "reimburseowner_details" ||
                    props?.popType === "ownerStatement"
                      ? true
                      : !(
                          services?.includes("IVAccount") ||
                          services?.includes("Admin")
                        )
                  }
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-card)"
                  isLoading={false}
                  icon={ICONS?.LINKED_WHITE_CIRCLE}
                  hoverOption="white"
                  fullWidthRequired={true}
                />
              </div>

              <div className="details-div-section w-screen">
                <div className="detail-section-trans h-auto m-auto max-w-tab-width-normal">
                  <div className="flex pt-padding-md px-padding-md lg:px-padding-base">
                    <div className="flex switch-tab-parent gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden ">
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Details",
                            key: "details",
                            handler: toggleDetails,
                          },
                          {
                            label: "Statistics",
                            key: "statistics",
                            handler: handleStatistics,
                            isDisabled: !(
                              ownerDetailData?.connected_banking === "Y" &&
                              (services?.includes("Admin") ||
                                services?.includes("VAccountBalance"))
                            ),
                          },
                          {
                            label: "Tags",
                            key: "assigned_tags",
                            handler: toggleAdditionalDetails,
                          },
                          {
                            label: "Labels",
                            key: "labels",
                            handler: toggleLabelDetails,
                          },
                        ]}
                        initialActiveTab={
                          showDetails
                            ? "details"
                            : showStatistics
                              ? "statistics"
                              : showAssignedTags
                                ? "assigned_tags"
                                : "labels"
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero &&
                    showDetails && (
                      <div className={animationClass}>
                        <div
                          key={ownerDetailData?.id}
                          className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md"
                        >
                          <CommonDetailCard
                            cardTitle="Bank Details"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={bankDetailsEntries}
                          />

                          <CommonDetailCard
                            cardTitle="Owner Details"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={ownerDetailsEntries}
                          />

                          <CommonDetailCard
                            cardTitle="Support Information"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="third"
                            entries={supportDetailsEntries}
                          />
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckOne &&
                    showStatistics && (
                      <div className={animationClass}>
                        <div className="px-padding-md lg:px-padding-base statistics-card-row">
                          <div className="statistics-user-message">
                            Missed potential income is calculated only for the
                            days the bank statement is available.
                          </div>
                          <div className="statistics-first-card flex flex-col-reverse Qsmd:flex-row w-width-full">
                            <div className="statistics-first-card-left relative flex flex-col min-h-graphic-square-height-lg flex-shrink-0 w-width-full border-r-border-base Qsmd:border-r border-primary-bg Qsmd:w-width-md-2-3 mt-margin-md Qsmd:mt-margin-base">
                              <p className="statistics-second-card-p1">
                                Missed potential income for last 7 days
                              </p>
                              <p
                                className={`statistics-second-card-p2 pb-padding-md`}
                              >
                                Income that could have been generated if the
                                idle amount had been invested through Xpentra.
                              </p>

                              <div className="statistics-first-card-left-div flex flex-1 items-center justify-center">
                                {getOwnerAccWeekStatiticsLoading ? (
                                  <div className="statistics-graph-no-data">
                                    <SVGComponent
                                      url={ICONS?.LOADER_GIF}
                                      height={"var(--icon-lg)"}
                                      width={"var(--icon-lg)"}
                                    />
                                  </div>
                                ) : (
                                  <div className="w-full">
                                    {accountBalancesReportWeekData?.length >
                                    GlobalConfiguration?.lengthCheckZero ? (
                                      <>
                                        <OwnerAccountStatisticsGraph
                                          missedIncomeGraphData={
                                            missedIncomeGraphData
                                          }
                                          actualIncomeGraphData={
                                            actualIncomeGraphData
                                          }
                                          amountRangeValue={amountRangeValue}
                                          pastSevenDays={pastSevenDays}
                                        />
                                        <div className="text-center text-text-primary text-font-sm">
                                          Last 7 days
                                        </div>
                                      </>
                                    ) : (
                                      <div className="statistics-graph-no-data">
                                        <div>
                                          <SVGComponent
                                            url={ICONS?.NO_STATISTICS_AVAILABLE}
                                            height={
                                              "var(--graphic-square-height-md)"
                                            }
                                            width={"var(--graphic-width-md)"}
                                          />
                                          <div className="statistics-graph-no-data-text text-wrap">
                                            {accountBalancesReportWeekError}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="pl-padding-base Qsmd:pl-padding-md flex flex-col statistics-first-card-right relative Qsmd:w-width-sm-1-3 w-width-full">
                              <div className="statistics-first-card-right-div">
                                <p className="statistics-first-card-right-text">
                                  Amount range
                                </p>
                                <div className="statistics-first-card-right-dropdown">
                                  <SingleSelectDropDownComponent
                                    type="small"
                                    options={[
                                      "Absolute (amount)",
                                      "Amount in lakhs",
                                      "Amount in crores",
                                      "Amount in millions",
                                      "Amount in billions",
                                    ]}
                                    selected={amountRange}
                                    setSelected={(value) => {
                                      if (!value || value === "") {
                                        setAmountRange("Absolute (amount)");
                                        setAmountRangeValue("");
                                        return;
                                      }

                                      setAmountRange(value);

                                      if (value === "Absolute (amount)")
                                        setAmountRangeValue("");
                                      else if (value === "Amount in lakhs")
                                        setAmountRangeValue("Lakhs");
                                      else if (value === "Amount in crores")
                                        setAmountRangeValue("Crores");
                                      else if (value === "Amount in millions")
                                        setAmountRangeValue("Millions");
                                      else if (value === "Amount in billions")
                                        setAmountRangeValue("Billions");
                                    }}
                                    showSearch={false}
                                    placeholder="Select type"
                                  />
                                </div>
                                <div
                                  style={{
                                    borderBottom:
                                      "var(--border) solid var(--primary-card)",
                                    marginTop: "var(--margin-md)",
                                  }}
                                ></div>
                              </div>

                              {/* <div className="mt-margin-sm">
                                <p className="statistics-first-card-right-text">
                                  Investment schemes
                                </p>
                                <div>
                                  <OwnerAccStatisticsDropdown
                                    setInvestmentRate={setInvestmentRate}
                                    investmentRate={investmentRate}
                                    selectInvestmentRate={selectInvestmentRate}
                                    setSelectInvestmentRate={
                                      setSelectInvestmentRate
                                    }
                                    setInvestmentRateValue={
                                      setInvestmentRateValue
                                    }
                                    investmentRateValue={investmentRateValue}
                                    setInfoState={setInfoState}
                                    type="investment"
                                  />
                                </div>
                               </div> */}
                              <div className="flex flex-col justify-between flex-1">
                                <div>
                                  <div className="flex">
                                    <span className=" text-queued text-font-md font-semibold relative">
                                      INR{" "}
                                      {
                                        formatTotalBalance(
                                          accountBalancesReportWeekAllData?.accrued_interest_amount ||
                                            GlobalConfiguration?.lengthCheckZero,
                                          amountRangeValue !== ""
                                            ? amountRangeValue
                                            : "amount",
                                        ).amount
                                      }
                                    </span>{" "}
                                    <div
                                      onClick={() => {
                                        setInfoState(!infoState);
                                      }}
                                      ref={infoRef}
                                      className="ml-margin-xs cursor-pointer"
                                    >
                                      <SVGComponent
                                        url={ICONS?.INFO}
                                        height={"var(--icon-sm)"}
                                        width={"var(--icon-sm)"}
                                      />
                                    </div>
                                    {infoState ? (
                                      <div className="absolute mt-margin-lg text-font-xs text-text-primary bg-primary-nav-act rounded-border-radius-sm px-padding-md py-padding-md z-z-index-content">
                                        This amount is based on the interest
                                        that could have earned by auto-investing
                                        using Xpentra, calculated at 6.5% of the
                                        idle funds.
                                      </div>
                                    ) : null}
                                  </div>
                                  <p className="text-font-xs text-text-primary">
                                    Total missed potential income
                                  </p>
                                </div>

                                <div className="flex Qsmd:flex-col gap-gap-md Qsmd:gap-gap-base mt-margin-md Qsmd:mt-margin-base">
                                  <div className="flex  mb-margin-base Qsmd:mb-margin-sm items-center">
                                    <div className="w-icon-md h-icon-md bg-custom-red rounded-border-radius-xs"></div>
                                    <p className="ml-margin-sm text-text-primary text-font-xs font-semibold">
                                      Actual income
                                    </p>
                                  </div>
                                  <div className="flex items-center">
                                    <div className="w-icon-md h-icon-md bg-queued rounded-border-radius-xs"></div>
                                    <p className="ml-margin-sm text-text-primary text-font-xs font-semibold">
                                      Missed potential income*
                                    </p>
                                  </div>
                                  <div className="mt-margin-sm Qsmd:flex hidden">
                                    <p className="text-text-secondary text-font-xs font-normal">
                                      * Amounts rounded off as per banking
                                      standards.
                                    </p>
                                  </div>
                                </div>
                                <div className="mt-margin-sm Qsmd:hidden flex">
                                  <p className="text-text-secondary text-font-xs font-normal">
                                    * Amounts rounded off as per banking
                                    standards.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`assigned-card-row px-padding-md lg:px-padding-base pb-padding-md`}
                        >
                          <div
                            className="statistics-second-card"
                            style={{ height: "auto" }}
                          >
                            <div className="bg-primary-nav rounded-t-border-radius-md">
                              <div className="statistics-second-card-top-bar flex flex-col Qsmd:flex-row">
                                <div className="statistics-second-card-summary">
                                  <p className="statistics-second-card-p1">
                                    Balance summary
                                  </p>
                                  <p className="statistics-second-card-p2">
                                    Daily balance summary of this account
                                  </p>
                                </div>
                                <div>
                                  <div className="relative pb-padding-xs">
                                    <div className="pt-padding-md Qsmd:pt-padding-base flex justify-end">
                                      <CommonCalendar
                                        startDate={startDateState}
                                        endDate={endDateState}
                                        handleDateChange={handleDateChange2}
                                        type="small"
                                        selectionType="range"
                                      />
                                    </div>
                                  </div>
                                  <div className="statistics-date-note">
                                    Start and end dates must be within a 6-month
                                    period.
                                  </div>
                                </div>
                              </div>
                              <div className="border border-primary-bg mx-margin-md"></div>
                              <div className="statistics-second-card-middle-bar gap-gap-md flex flex-col Qsmd:flex-row">
                                <div>
                                  <p className="statistics-second-card-p1-total">
                                    Total missed potential income
                                  </p>
                                  <p className="statistics-second-card-p3">
                                    From{" "}
                                    {formatDate(startDate, true, false, true)}{" "}
                                    to {formatDate(endDate, true, false, true)}
                                  </p>
                                </div>
                                <div className="relative">
                                  <span className="statistics-second-card-span absolute Qsmd:right-right-base">
                                    INR{" "}
                                    {
                                      formatTotalBalance(
                                        accountBalancesReportAllData?.accrued_interest_amount ||
                                          GlobalConfiguration?.lengthCheckZero,
                                        amountRangeValue !== ""
                                          ? amountRangeValue
                                          : "amount",
                                      ).amount
                                    }
                                  </span>
                                  <div className="mt-margin-md">
                                    <p className="text-text-secondary text-font-xs font-normal">
                                      * Amounts rounded off as per banking
                                      standards.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="statistics-second-card-header-bar grid grid-cols-5">
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Date
                              </div>
                              <div className="statistics-second-card-header-bar-div2 py-padding-md">
                                Closing balance
                              </div>
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Minimum balance
                              </div>
                              <div className="statistics-second-card-header-bar-div2 py-padding-md">
                                Idle funds
                              </div>
                              <div className="p-padding-sm Qsmd:p-padding-md">
                                Missed potential income
                              </div>
                            </div>
                            <div
                              className="statistics-second-card-data-div"
                              style={{
                                overflowY:
                                  accountBalancesReportData?.length >
                                  GlobalConfiguration?.lengthCheckZero
                                    ? "auto"
                                    : "hidden",
                              }}
                            >
                              {getOwnerAccStatiticsLoading ? (
                                <>
                                  <div className="statistics-graph-no-data mt-margin-xl">
                                    <SVGComponent
                                      url={ICONS?.LOADER_GIF}
                                      height={"var(--icon-lg)"}
                                      width={"var(--icon-lg)"}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  {accountBalancesReportData?.length >
                                  GlobalConfiguration?.lengthCheckZero ? (
                                    accountBalancesReportData.map(
                                      (data, index) => {
                                        return (
                                          <div
                                            className="statistics-second-card-data-bars"
                                            style={{
                                              borderBottom:
                                                accountBalancesReportData?.length -
                                                  GlobalConfiguration?.lengthCheckOne ===
                                                index
                                                  ? ""
                                                  : "var(--border) solid var(--primary-bg)",
                                            }}
                                          >
                                            <div className="statistics-second-card-data-div-date">
                                              {formatDate(
                                                data?.date,
                                                false,
                                                true,
                                              )}
                                            </div>
                                            <div className="statistics-second-card-data-div-amount1">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.closing_balance),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                            <div className="statistics-second-card-data-div-amount2">
                                              INR 0.00
                                            </div>
                                            <div className="statistics-second-card-data-div-amount3">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.closing_balance),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                            <div className="statistics-second-card-data-div-income">
                                              INR{" "}
                                              {
                                                formatTotalBalance(
                                                  Number(data?.daily_interest),
                                                  amountRangeValue !== ""
                                                    ? amountRangeValue
                                                    : "amount",
                                                ).amount
                                              }
                                            </div>
                                          </div>
                                        );
                                      },
                                    )
                                  ) : (
                                    <div className="statistics-second-card-no-data">
                                      <div>
                                        <SVGComponent
                                          url={ICONS?.NO_STATISTICS_AVAILABLE}
                                          height={
                                            "var(--graphic-square-height-md)"
                                          }
                                          width={"var(--graphic-width-md)"}
                                        />
                                        <div className="statistics-second-card-no-data-text text-wrap">
                                          {accountBalancesReportError}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckTwo &&
                    showAssignedTags && (
                      <div className={animationClass}>
                        <div className="mt-margin-md pb-padding-md">
                          <CommonContainerCard
                            header="Tags"
                            subheader={TEXT?.TAG_INSTRUCTION}
                            iconIsDisabled={
                              props?.popType == "reimburseowner_details" ||
                              props?.popType == "ownerStatement"
                                ? true
                                : false
                            }
                            icon={ICONS?.EDIT}
                            handleFunction={() => {
                              if (
                                props?.popType == "ownerStatement" ||
                                props?.popType == "reimburseowner_details"
                              ) {
                                actionRestricted();
                              } else if (
                                !services?.includes("COwnerTag") &&
                                !services?.includes("DOwnerTag")
                              ) {
                                navigate("/feature_not_assigned");
                              } else {
                                {
                                  handleSelectedtag();
                                }
                              }
                            }}
                          >
                            <div className="flex gap-gap-sm flex-wrap">
                              {haveName ? (
                                newTags
                                  ?.filter((tag) => tag.type === "ownerTags")
                                  ?.map((tag) => {
                                    return (
                                      <>
                                        <Chips
                                          txtChip={tag?.value}
                                          enabledBgColor="var(--primary-nav)"
                                          enabledTextColor="var(--text-primary)"
                                          isTickerRequired={true}
                                        />
                                      </>
                                    );
                                  })
                              ) : (
                                <p className="NotagsAssigned">
                                  No tags assigned to this account.
                                </p>
                              )}
                            </div>
                          </CommonContainerCard>
                        </div>
                      </div>
                    )}
                  {index === GlobalConfiguration?.lengthCheckThree && (
                    <div className={animationClass}>
                      <div className="mt-margin-md pb-padding-md">
                        <CommonContainerCard
                          header="Labels"
                          subheader={TEXT?.LABELS_STATS_USAGE_NOTE}
                          iconIsDisabled={
                            props?.popType === "reimburseowner_details" ||
                            props?.popType === "ownerStatement"
                              ? true
                              : false
                          }
                          icon={ICONS?.EDIT}
                          handleFunction={handleClick}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    enabledTextColor="var(--text-primary)"
                                    isTickerRequired={false}
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default OwnerAccountDetails;
